import HTTP_METHOD from "enums/HTTP_METHOD";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";
import AuthDto from "types/AuthDto";

interface MfaVerifyPayload {
  challengeToken: string;
  code: string;
  rememberDevice: boolean;
}

export default function usePostMfaVerify() {
  const { write, ...rest } = useApiWrite();

  const postMfaVerify = (payload: MfaVerifyPayload): Promise<AuthDto> =>
    write<AuthDto>({
      url: endpoints.postMfaVerify(),
      method: HTTP_METHOD.POST,
      suppressErrorNotification: true,
      data: payload,
    }).then(({ data }) => data);

  return {
    postMfaVerify,
    ...rest,
  };
}
